import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import './styles/tokens.css'
import './styles/admin-theme.css'
import './styles/vuetify-overrides.css'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#CDB27A',
          'primary-darken-1': '#C2A569',
          'primary-darken-2': '#917A4B',
          secondary: '#917A4B',
          background: '#F5F5F5',
          surface: '#FFFFFF',
          error: '#B00020',
          warning: '#E65100',
          info: '#1565C0',
          success: '#2E7D32',
        },
      },
    },
  },
})

createApp(App).use(router).use(vuetify).mount('#app')
